import { render, staticRenderFns } from "./WechatPosition.vue?vue&type=template&id=b76c5bb6&scoped=true&"
import script from "./WechatPosition.vue?vue&type=script&lang=js&"
export * from "./WechatPosition.vue?vue&type=script&lang=js&"
import style0 from "./WechatPosition.vue?vue&type=style&index=0&id=b76c5bb6&scoped=true&lang=css&"
import style1 from "./WechatPosition.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c5bb6",
  null
  
)

export default component.exports